<template>
    <div>
        <Loading :isLoading="isLoading" />
        <CRow style="height:100% !important">
            <CCol col="12" xl="12" style="height:100% !important">
                <transition name="slide">
                    <CCard style="height:100% !important">
                        <CCardBody height="100%">
                            <CRow v-if="data.length === 0 && !isLoading">
                                <div class="col-sm-6 offset-sm-3 text-center">
                                    No hay imagenes disponibles
                                </div>
                            </CRow>
                            <CRow v-for="item of data" :key="item.id">
                                <div class="col-sm-6 offset-sm-3">
                                    <CCard>
                                        <CCardBody>
                                            <a
                                                :href="item.link_url"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                @click="onOpenImage($event, item)"
                                            >
                                                <img
                                                    :src="item.url"
                                                    alt="Galeria de transportistas"
                                                    class="carrier-gallery-image"
                                                />
                                            </a>
                                        </CCardBody>
                                    </CCard>
                                </div>
                            </CRow>
                        </CCardBody>
                    </CCard>
                </transition>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from "../../components/Loading.vue";

export default {
    name: 'CarrierGallery',
    components: {
        Loading,
    },
    data() {
        return {
            data: [],
            isLoading: true,
        }
    },
    methods: {
        onOpenImage(event, item) {
            if (item.link_url == null || String(item.link_url).trim().length === 0) {
                event.preventDefault();
            }
        },
        onGetRecords() {
            axios.get('carrier-gallery')
                .then(response => {
                    this.data = response.data;
                }).catch(error => {
                    if (error.response && error.response.status === 401) {
                        this.$router.push({ path: '/login' });
                    } else if (error.response && error.response.data) {
                        this.$toast.error(error.response.data.message);
                    }
                }).finally(() => {
                    this.isLoading = false;
                });
        },
    },
    mounted() {
        this.onGetRecords();
    }
}
</script>

<style scoped>
.carrier-gallery-image {
    width: 100%;
    height: auto;
    max-height: 420px;
    object-fit: contain;
}
</style>
